import React from 'react';
import { motion } from 'framer-motion';
import { Gift, CheckCircle2 } from 'lucide-react';
export function BonusSection() {
  const bonuses = [{
    num: '01',
    title: 'Kit SOS 24 Horas',
    items: ['Tu protocolo de rescate cuando llevás 4+ días sin ir y necesitás una solución ahora mismo, sin laxantes químicos irritantes.', 'Niveles 1, 2 y 3 según la severidad', 'Compresas de jengibre y Masaje profundo de emergencia', 'Osmosis de choque y El Cóctel de Ciruela concentrado', 'Protocolo de día líquido y Checklist completo'],
    value: '$12.000'
  }, {
    num: '02',
    title: 'Guía de Magnesio para Argentina',
    items: ['Qué comprar exactamente en la farmacia de tu barrio. Sin gastar más en el magnesio equivocado.', 'Los 8 tipos con semáforo de eficacia', 'Directorio de marcas argentinas', 'Test de 3 preguntas para saber cuál es el tuyo', 'Dosificación personalizada por peso y severidad'],
    value: '$10.000'
  }, {
    num: '03',
    title: 'Desayunos Mueve-Montañas',
    items: ['15 recetas de desayuno diseñadas para activar el reflejo gastro-cólico antes de las 9 AM.', 'Los 5 ingredientes gatillo y La ciencia de la temperatura', 'Recetas en 3 a 15 minutos y Versiones de take-away', 'El protocolo de los 20 minutos'],
    value: '$9.000'
  }, {
    num: '04',
    title: 'El Diario del Detective Digestivo',
    items: ['90 días de registro que convierten la confusión en certeza. Tu herramienta de diagnóstico personal.', 'La Escala de Bristol PRO', 'Plantillas diarias de 2 minutos y Detector de gatillos', 'Tracker hormonal y Evaluaciones semanales'],
    value: '$11.000'
  }, {
    num: '05',
    title: 'Meditaciones del Trono',
    items: ['Guiones de meditación y técnicas mentales para relajar el Nervio Vago y liberar el esfínter.', '4 guiones completos y La Respiración del Océano', 'Escaneo somático y Técnica del Ancla de Calma', 'Meditación para baños ajenos y El Contrato de Calma'],
    value: '$10.000'
  }];
  return <section className="py-24 bg-brand-black relative overflow-hidden" data-id="element-29">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-4xl h-[600px] bg-brand-gold/5 blur-[150px] rounded-full pointer-events-none" data-id="element-30" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-31">
        <div className="max-w-5xl mx-auto" data-id="element-32">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-16" data-id="element-33">
            <h2 className="text-3xl md:text-5xl font-bold text-brand-gold mb-4 flex flex-col md:flex-row items-center justify-center gap-4 font-[Poppins,_sans-serif]" data-id="element-34">
              <Gift className="w-10 h-10" data-id="element-35" />5 BONOS ESTRATÉGICOS
            </h2>
            <p className="text-xl text-white font-medium tracking-widest uppercase" data-id="element-36">
              Siempre Incluidos
            </p>
          </motion.div>

          <div className="grid gap-6 mb-16" data-id="element-37">
            {bonuses.map((bonus, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-brand-dark border border-brand-gold/20 p-6 md:p-8 rounded-2xl flex flex-col md:flex-row gap-6 items-start relative overflow-hidden group hover:border-brand-gold/50 transition-colors" data-id="element-38">
                <div className="bg-brand-gold/10 text-brand-gold font-bold text-xl px-4 py-2 rounded-lg shrink-0" data-id="element-39">
                  BONO {bonus.num}
                </div>

                <div className="flex-grow z-10" data-id="element-40">
                  <h3 className="text-xl font-bold text-white mb-3" data-id="element-41">
                    {bonus.title}
                  </h3>
                  <ul className="space-y-2" data-id="element-42">
                    {bonus.items.map((item, i) => <li key={i} className="flex items-start gap-2 text-gray-300" data-id="element-43">
                        <CheckCircle2 className="w-5 h-5 text-brand-gold shrink-0 mt-0.5" data-id="element-44" />
                        <span data-id="element-45">{item}</span>
                      </li>)}
                  </ul>
                </div>

                <div className="shrink-0 flex flex-row items-center gap-3 z-10" data-id="element-46">
                  <span className="text-gray-500 line-through text-sm" data-id="element-47">
                    {bonus.value}
                  </span>
                  <span className="bg-brand-light text-brand-dark font-bold px-4 py-1 rounded-full" data-id="element-48">
                    GRATIS
                  </span>
                </div>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="bg-brand-gold/10 border border-brand-gold/30 py-8 px-6 rounded-2xl flex flex-col items-center justify-center gap-2" data-id="element-49">
            <p className="text-sm md:text-base font-semibold tracking-widest uppercase text-[#D4A843]" data-id="element-50">
              VALOR TOTAL BONOS
            </p>
            <p className="text-3xl md:text-4xl font-bold text-gray-400 line-through" data-id="element-51">
              $52.000
            </p>
            <p className="text-xl md:text-2xl text-brand-gold font-bold text-center" data-id="element-52">
              → GRATIS con tu Sistema Despertar Liviana™
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}